import { render } from "./ReviewOnboardComponent.vue?vue&type=template&id=2eee4c6e&scoped=true"
import script from "./ReviewOnboardComponent.vue?vue&type=script&lang=js"
export * from "./ReviewOnboardComponent.vue?vue&type=script&lang=js"

import "./ReviewOnboardComponent.vue?vue&type=style&index=0&id=2eee4c6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eee4c6e"]])

export default __exports__